<template>
  <div class="column is-2">
    <div class="columns is-multiline">
      <div class="column is-12">
        <figure class="image is-128x128">
          <img src="https://bulma.io/images/placeholders/128x128.png">
        </figure>
      </div>
      <div class="column is-12">
        <aside class="menu">
          <p class="menu-label">
            Profile
          </p>
          <ul class="menu-list">
            <li><a @click="goToSection('profile')">Profile</a></li>
            <li><a @click="goToSection('profile_update')">Update Profile</a></li>
            <li><a @click="goToSection('change_password')">Change Password</a></li>
          </ul>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page_section: ''
    }
  },
  methods: {
    goToSection (value) {
      this.$geb.emit({id: 'profile_section_event', eventData: value})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/profile/components/ProfileMenu.vue